import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-admissionoffices',
    templateUrl: './admissionoffices.component.html',
    styleUrls: ['./admissionoffices.component.scss']
})
export class AdmissionofficesComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titles: Title
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Admission Office: Your Gateway to a Bright Future');
        this.meta.updateTag({
            name: 'description',
            content: `Visit ARNI Admission Office for guidance on the application process, admission requirements, and opportunities to join our vibrant academic community.`
        });
    }

}
